import React from 'react';
import { Link } from 'react-router-dom';

const ForWholesalePage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Для торговых компаний</h1>
      
      <div className="prose max-w-none">
        <p className="text-lg mb-8">
          Компания «Теплогранд» предлагает эксклюзивные условия сотрудничества для торговых компаний. Мы предоставляем полный спектр услуг: от подбора оборудования и формирования ассортиментной матрицы до его оперативной доставки конечному клиенту.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-semibold mb-4">Преимущества сотрудничества</h2>
            <ul className="list-disc pl-6">
              <li>Специальные условия и гибкая система скидок</li>
              <li>Выгодные оптовые цены</li>
              <li>Бонусы за объем закупок</li>
              <li>Индивидуальные условия оплаты</li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-semibold mb-4">Логистика</h2>
            <ul className="list-disc pl-6">
              <li>Доставка по всей России</li>
              <li>Оперативная отгрузка</li>
              <li>Бесплатная доставка до терминала транспортной компании</li>
            </ul>
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg p-8 mt-8">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-semibold mb-4">Стать оптовым партнером</h2>
            <p className="mb-6">
              Чтобы получить оптовый прайс-лист и подробную информацию о сотрудничестве, оставьте заявку или свяжитесь с нашим отделом продаж.
            </p>
            <Link 
              to="/callback"
              className="bg-primary text-white px-8 py-3 rounded-md hover:bg-primary-dark transition-colors"
            >
              Получить оптовый прайс-лист
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForWholesalePage; 